/**
 * Parses a Go template string and replaces {{.Key}} with values from data object.
 * Supports nested keys like {{.User.Name}}.
 * @param {string} template - The Go template string.
 * @param {object} data - The data object.
 * @returns {string} - The parsed string.
 */
function parseGolangTemplate(template, data) {
  return template.replace(/{{\s*\.(\w+(?:\.\w+)*)\s*}}/g, (_, path) => {
    const keys = path.split('.')
    let value = data
    for (const key of keys) {
      value = value?.[key]
      if (value === undefined) return ''
    }
    return value
  })
}

module.exports = { parseGolangTemplate }
